import React, { useState, useEffect, useRef } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Table from "../../Components/Request/Table";
import RejectModal from "../../Components/Request/RejectModal";
import InitiateTenantEviction from "../../Components/Dues/InitiateTenantEviction";
import ViewRequest from "../../Components/Request/ViewRequest";
import OfflineRefundModal from "../../Components/Dues/OfflineRefundModal";
import OnboardingRequestModal from "../../Components/Request/OnboardingRequestModal";
import SideModal from "../../Components/SideModal";
import RequestAcceptModal from "../../Components/Request/RequestAcceptModal";
import GuestReqAccept from "../../Components/Request/GuestReqAccept";
import { IoFilter } from "react-icons/io5";
import RequestFilter from "../../Components/Request/RequestFilter";
import SummaryCards from "../../Components/Request/SummaryCard";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";

const Requests = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [isReqRej, setIsReqRej] = useState(false);
  const [isReqAccept, setIsReqAccept] = useState(false);
  const [isGuestReqAccept, setIsGuestReqAccept] = useState(false);
  const [initiateEviction, setInitiateEviction] = useState(false);
  const [isViewReq, setIsViewReq] = useState(false);
  const [isReturnDeposit, setIsReturnDeposit] = useState(false);
  const [onboardingRequestAccept, setOnboardingRequestAccept] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("");
  const btnRef = useRef(null);
  const [selectedType, setSelectedType] = useState(null);
  const [type, setType] = useState("");
  const [masterData, setMasterData] = useState();
  const [summary, setSummary] = useState(null);

  const [showOnlineRefundModal, setShowOnlineRefundModal] = useState(false);
  const [showOfflineRefundModal, setShowOfflineRefundModal] = useState(false);

  const query = `type=${type}`;
  const fetchFunction = async () => {
    const response = await axios.get(`${Config.apiUrl}/client/request/list?${query}`, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess) {
      setApiData(res.data);
      setMasterData(res.data);
      setSummary(generateSummary(res.data));
      setIsFocused(true);
    }
  };

  const generateSummary = (data) => {
    return {
      total: data.length,
      onboarding: data.filter(
        item => item.type === Config.REQUEST_TYPE.ONBOARDING,
      ).length,
      moveout: data.filter(
        item => item.type === Config.REQUEST_TYPE.MOVEOUT,
      ).length,
      guest: data.filter(
        item => item.type === Config.REQUEST_TYPE.GUEST,
      ).length,
      refund: data.filter(
        item => item.type === Config.REQUEST_TYPE.REFUND,
      ).length,
    };
  };

  const getError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
    data,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate();
  }, []);

  //------- Move Out Request Reject Model -------
  const MoveOutReqRejFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/tenant/request/reject`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const reqRejSuccess = (data) => {
    setIsReqRej(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const reqRejError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: reqRejLoading, mutate: reqRejMutate } = useMutation(
    MoveOutReqRejFunction,
    {
      onSuccess: reqRejSuccess,
      onError: reqRejError,
    }
  );

  //------- Onboarding Request Reject Model -------
  const OnboardingReqRejFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/request/reject`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const onboardingReqRejSuccess = (data) => {
    setIsReqRej(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const onboardingReqRejError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: onboardingReqRejLoading, mutate: onboardingReqRejMutate } = useMutation(
    OnboardingReqRejFunction,
    {
      onSuccess: onboardingReqRejSuccess,
      onError: onboardingReqRejError,
    }
  );

  //------- Refund Request Reject Model -------
  // const RefundReqRejFunction = async (values) => {
  //   return await axios.post(`${Config.apiUrl}/tenant/request/refund/reject`, values, {
  //     headers: {
  //       "Content-Type": "application/json",
  //       authorization: `Bearer ${user.token}`,
  //     },
  //   });
  // };

  // const refundReqRejSuccess = (data) => {
  //   setIsReqRej(false);
  //   getListMutate();
  //   toast.success(data?.data?.msg || "Success");
  // };

  // const refundReqRejError = (data) => {
  //   toast.error(data?.response?.data?.msg || "An Error Occured");
  // };

  // const { isLoading: refundReqRejLoading, mutate: refundReqRejMutate } = useMutation(
  //   RefundReqRejFunction,
  //   {
  //     onSuccess: refundReqRejSuccess,
  //     onError: refundReqRejError,
  //   }
  // );

  //------- Refund Request Model -------
  const RefundReqFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/client/request/refund/consent`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const refundReqSuccess = (data) => {
    setIsReqRej(false)
    setIsReqAccept(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const refundReqError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: refundReqLoading, mutate: refundReqMutate } = useMutation(
    RefundReqFunction,
    {
      onSuccess: refundReqSuccess,
      onError: refundReqError,
    }
  );

  //------- Guest Request Model -------
  const GuestReqFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/client/request/guest/consent`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const guestReqSuccess = (data) => {
    setIsReqRej(false)
    setIsViewReq(false);
    setIsGuestReqAccept(false)
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const guestReqError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: guestReqLoading, mutate: guestReqMutate } = useMutation(
    GuestReqFunction,
    {
      onSuccess: guestReqSuccess,
      onError: guestReqError,
    }
  );

  //------- Refund Model -------
  const ReturnDepositFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/due/settle/excess/after/eviction`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const returnDepositSuccess = (data) => {
    setShowOfflineRefundModal(false);

    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const returnDepositError = (data) => {
    setShowOfflineRefundModal(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: returnDepositLoading, mutate: returnDepositMutate } =
    useMutation(ReturnDepositFunction, {
      onSuccess: returnDepositSuccess,
      onError: returnDepositError,
    });

  //------- Approve Tenant Model -------
  const ApproveTenantFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/room/request/approve`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const approveTenantSuccess = (data) => {
    setOnboardingRequestAccept(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const approvetenantError = (data) => {
    setOnboardingRequestAccept(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: onboardingRequestLoading, mutate: onboardingRequestMutate } =
    useMutation(ApproveTenantFunction, {
      onSuccess: approveTenantSuccess,
      onError: approvetenantError,
    });

  const onApplyFilter = (typeValue) => {
    setType(typeValue);
    setActiveFilter("1");
    setIsFilterOpen(false);
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);
  };

  const handleFilterClose = () => {
    setActiveFilter("");
    setType("");
    setIsFilterOpen(false);
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);
  };

  const onSummaryBoxClick = (data) => {
    let filteredData;
    if (data === "O")
      //Onboarding
      filteredData = masterData.filter((item) => item.type === Config.REQUEST_TYPE.ONBOARDING);
    else if (data === "M")
      //Moveout
      filteredData = masterData.filter((item) => item.type === Config.REQUEST_TYPE.MOVEOUT);
    else if (data === "G")
      //Guest
      filteredData = masterData.filter((item) => item.type === Config.REQUEST_TYPE.GUEST);
    else if (data === "R")
      //Refund
      filteredData = masterData.filter((item) => item.type === Config.REQUEST_TYPE.REFUND);
    else filteredData = masterData;
    setApiData(filteredData);
  };

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Requests
          <Underline />
        </BoxTitle>

      </BoxHead>


      <SideModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)}>
        <RequestFilter
          setIsFilterOpen={setIsFilterOpen}
          onApplyFilter={onApplyFilter}
          selectedData={selectedData}
          handleClose={() => setIsFilterOpen(false)}
          handleClear={handleFilterClose}
          selected={null}
          setSelectedType={setSelectedType}
          selectedType={selectedType}
        />
      </SideModal>

      {isReqRej && (
        <RejectModal
          setIsReqRej={setIsReqRej}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          reqRejLoading={reqRejLoading}
          reqRejMutate={reqRejMutate}
          onboardingReqRejLoading={onboardingReqRejLoading}
          onboardingReqRejMutate={onboardingReqRejMutate}
          // refundReqRejLoading={refundReqRejLoading}
          // refundReqRejMutate={refundReqRejMutate}
          refundReqMutate={refundReqMutate}
          refundReqLoading={refundReqLoading}
          guestReqLoading={guestReqLoading}
          guestReqMutate={guestReqMutate}
        />
      )}

      {isReqAccept && (
        <RequestAcceptModal
          setIsReqAccept={setIsReqAccept}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          refundReqLoading={refundReqLoading}
          refundReqMutate={refundReqMutate}
        />
      )}

      <SideModal
        isOpen={showOfflineRefundModal}
        onClose={() => setShowOfflineRefundModal(false)}
      >
        <OfflineRefundModal
          setShowOfflineRefundModal={setShowOfflineRefundModal}
          returnDepositMutate={returnDepositMutate}
          returnDepositLoading={returnDepositLoading}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
        />
      </SideModal>

      <SideModal
        isOpen={isGuestReqAccept}
        onClose={() => setIsGuestReqAccept(false)}
        level="high"
        width="1/3"
      >
        <GuestReqAccept
          setIsGuestReqAccept={setIsGuestReqAccept}
          guestReqMutate={guestReqMutate}
          guestReqLoading={guestReqLoading}
          isGuestReqAccept={isGuestReqAccept}
          selectedData={selectedData}
          setSelectedData={setSelectedData}

        />
      </SideModal>

      <SideModal
        isOpen={onboardingRequestAccept}
        onClose={() => setOnboardingRequestAccept(false)}
      >
        <OnboardingRequestModal
          setOnboardingRequestAccept={setOnboardingRequestAccept}
          onboardingRequestMutate={onboardingRequestMutate}
          onboardingRequestLoading={onboardingRequestLoading}
          onboardingRequestAccept={onboardingRequestAccept}
          selectedData={selectedData}
          setSelectedData={setSelectedData}

        />
      </SideModal>

      <SideModal
        isOpen={initiateEviction}
        onClose={() => setInitiateEviction(false)}
      >
        <InitiateTenantEviction
          setInitiateEviction={setInitiateEviction}
          apiData={{
            name: selectedData.tenantName,
            kycStatus: selectedData.kycStatus,
            occupancy: {
              requestId: selectedData.id,
              tenantId: selectedData.tenantId,
              roomNum: selectedData.roomNum,
              floor: selectedData.floor,
              propName: selectedData.propertyName,
              flatname: selectedData.flatName,
              moveInDate: selectedData.moveInDate,
              agreementPeriod: selectedData.agreementPeriod,
              lockInPeriod: selectedData.lockInPeriod,
              noticePeriod: selectedData.noticePeriod,
              agreementStartDate: selectedData.agreementStartDate,
              moveOutDate: selectedData.moveOutDate,
              moveOutReason: selectedData.moveOutReason,
              otherDate: selectedData.otherDate,
              calculationType: selectedData.calculationType
            }
          }}
          refresh={getListMutate}
        />
      </SideModal>

      <SideModal
        isOpen={isViewReq}
        onClose={() => setIsViewReq(false)}
      >
        <ViewRequest
          setIsViewReq={setIsViewReq}
          selectedData={selectedData}
          setIsReqRej={setIsReqRej}
          setInitiateEviction={setInitiateEviction}
          setShowOfflineRefundModal={setShowOfflineRefundModal}
          setOnboardingRequestAccept={setOnboardingRequestAccept}
          setIsReqAccept={setIsReqAccept}
          setIsGuestReqAccept={setIsGuestReqAccept}
        />
      </SideModal>


      {(isLoading || isRefetching) && !isFocused && (
        <SummarySkeletonLoading count={4} />
      )}
      {!error && !isLoading && data && (
        // <TableWrapper>
        <>
          <SummaryCards summaryData={summary} onClick={onSummaryBoxClick} />
          <FilterTableWrapper>
            <FilterWrapper className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Left: Total Record */}
              <div className="flex items-center">
                <Text>
                  Total requests:{" "}
                  <span className="font-semibold">
                    {apiData?.length || 0}
                  </span>
                </Text>
              </div>
              <div className="flex gap-2 items-center justify-end">

                {/* Filter Button */}
                <div className="relative">
                  <FilterBtn
                    ref={btnRef}
                    type="button"
                    title="Type Filter"
                    onClick={() => setIsFilterOpen((v) => !v)}
                    className={`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto}`}
                  >
                    <IoFilter size={14} color="#9CA3AF" />
                  </FilterBtn>
                  {activeFilter && (
                    <span className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-400 rounded-full"></span>
                  )}

                </div>
              </div>
            </FilterWrapper>
            <TableWrapper>
              <Table
                apiData={apiData || []}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setIsReqRej={setIsReqRej}
                setInitiateEviction={setInitiateEviction}
                setIsViewReq={setIsViewReq}
                // setIsReturnDeposit={setIsReturnDeposit}
                setOnboardingRequestAccept={setOnboardingRequestAccept}
                setIsReqAccept={setIsReqAccept}
              />
              {(!apiData || apiData.length === 0) && <NotFoundModel msg={"No pending requests at the moment."} />}
            </TableWrapper>
          </FilterTableWrapper>
        </>
      )}

      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md`;
const FilterBtn = tw.button``;
const AddBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6 cursor-pointer bg-primary-color hover:bg-hover-color py-2.5 text-sm ml-auto`;
const Text = tw.p`text-gray-500 text-sm font-normal `;
export default Requests;

